import { Collapse, Button } from 'antd';
import React from 'react';
import "./faqs.scss";

const Faqs = () => {
  const items = [
    {
      key: '1',
      label: 'How do I list a property?',
      children: (
        <div style={{ paddingInlineStart: 24 }}>
          <ol>
            <li><strong>Sign Up/Login:</strong> Create an account or log in as a vendor.</li>
            <li><strong>Go to Your Dashboard:</strong> Navigate to the “Settings” section.</li>
            <li><strong>Click ‘My Properties’:</strong> Under the profile section, click on “My Properties”.</li>
            <li><strong>Click ‘Add Property’:</strong> Fill in details like location, price, property type, and features.</li>
            <li><strong>Upload Photos:</strong> Add high-quality images.</li>
            <li><strong>Submit for Review:</strong> Once approved, your listing will be live on the platform.</li>
          </ol>
        </div>
      ),
    },
    {
      key: '2',
      label: 'How can I edit or remove a listing?',
      children: (
        <div style={{ paddingInlineStart: 24 }}>
          <p><strong>Edit a Listing:</strong></p>
          <ol>
            <li>Log in to your account.</li>
            <li>Go to “Settings → My Profile → My Properties”.</li>
            <li>Select the property you want to edit and update the details.</li>
            <li>Save changes to update the listing instantly.</li>
          </ol>
        </div>
      ),
    },
    {
      key: '3',
      label: 'Is there a fee for listing a property?',
      children: (
        <div style={{ paddingInlineStart: 24 }}>
          <ul>
            <li><strong>Free Listings:</strong> All listings are free.</li>
            <li><strong>Premium Listings:</strong> There’s an option to boost your listing for better visibility through paid promotions so it can appear on featured.</li>
          </ul>
        </div>
      ),
    },
    {
      key: '4',
      label: 'How do I find properties to buy or rent?',
      children: (
        <div style={{ paddingInlineStart: 24 }}>
          <ul>
            <li>Use the search bar on the homepage.</li>
            <li>Apply filters (location, price range, property type, amenities).</li>
            <li>View properties on the interactive map.</li>
            <li>Contact the property owner or agent directly through the platform.</li>
          </ul>
        </div>
      ),
    },
    {
      key: '5',
      label: 'What should I do if I have a problem with a transaction?',
      children: (
        <div style={{ paddingInlineStart: 24 }}>
          <ul>
            <li><strong>Contact the Vendor:</strong> If you have issues with a seller, try to resolve it with them first.</li>
            <li><strong>Customer Support:</strong> Contact our support team via email, chat, or phone for assistance.</li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <div className="main-settings-container">
      <div className="faq">
        <h3>We are here to help you with anything and everything</h3>
        <Collapse items={items} bordered={false} defaultActiveKey={['1']} style={{ marginTop: 20 }} />
        <div style={{ display: "flex", gap: 20, marginTop: 20 }}>
          <h4>Still stuck? Help is a mail away</h4>
          <Button type="primary" size="normal">Send mail</Button>
        </div>
      </div>
    </div>
  );
};

export default Faqs;
